import { render, staticRenderFns } from "./DoctorGoobModal.vue?vue&type=template&id=67f23def&scoped=true&"
import script from "./DoctorGoobModal.vue?vue&type=script&lang=js&"
export * from "./DoctorGoobModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f23def",
  null
  
)

export default component.exports